module.exports = __webpack_public_path__ + "img/combo.71c87dc2.jpg";